import { render, staticRenderFns } from "./CatalogItemModal.vue?vue&type=template&id=b7a707d4&"
import script from "./CatalogItemModal.vue?vue&type=script&lang=ts&"
export * from "./CatalogItemModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports